import { render } from "./Statistics.vue?vue&type=template&id=af9b4efa&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=af9b4efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9b4efa"]])

export default __exports__